module.exports = __webpack_public_path__ + "static/img/banner3.b3b7e90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner3.jpg
// module id = GWCu
// module chunks = 12